import { useEffect, useState, useContext } from 'react'
import {Dropdown} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import ReportsService from '../../services/ReportsService'
import CommonService from '../../services/CommonService'
import { UserContext } from '../../UserContext'
import { AlertType } from '../../utils'
import DataGrid from '../GenericComponents/DataGrid'
import { Column } from 'primereact/column'
import { configManager } from '../../configManager'
//import TooltipComponent from '../../common/Tooltip'

const ADTRReports = (props) => {
    const loginUserId = useContext(UserContext);
    const { reportStatus, searchCriteria } = props;
    const navigate = useNavigate();
    const [adtrs, setAdtrs] = useState([]);

    useEffect(() => {
        getAdtrWorkLoad();
     // eslint-disable-next-line
    }, [searchCriteria]);

    const getAdtrWorkLoad = () => {
        CommonService.showHideSpinner(true);
        setAdtrs([]);
        let obj;
        if(reportStatus === "view-previous") {
            obj ={
                "msgId": null,
                "sysId": null,
                "opr": "getOldAdtrs",
                "hdrStruct": null,
                "queryParam": null,
                "reqData": {
                    "env" : 'I',
                    "searchCriteria": searchCriteria
                }
            }
        } else {
            obj ={
                "msgId": null,
                "sysId": null,
                "opr": "getPendingAdtrs",
                "hdrStruct": null,
                "queryParam": null,
                "reqData": {
                    "env" : 'I'
                }
            }
        } 
        ReportsService.getReports(obj)
        .then((res) => res)
        .then((result) => {
            CommonService.showHideSpinner(false);

            if(result.data.statusCode === 401 || result.data.statusCode === 500) {
                CommonService.displayServerMessage(result.data.errors[0].message, AlertType.Error)
            } else {
                setAdtrs(result.data.responses[0]);            
            }
        });
    }
    const actions = {
        'D' : [
            {value:'E', label: 'Edit'},
            {value:'C', label: 'Cancel'},
            {value:'SH', label: 'View History'}
        ],
        'S' : [
            {value:'E', label: 'Edit'},
            {value:'C', label: 'Cancel'},
            {value:'SH', label: 'View History'}
        ],
        'E' : [
            {value:'E', label: 'Edit'},
            {value:'SH', label: 'View History'}
        ],
        'R' : [
            {value:'E', label: 'Edit'},
            {value:'SH', label: 'View History'}
        ]
    }
    const viewFormatter = (row) => { 
        return ( 
            <div style={{ textAlign: "center", lineHeight: "normal" }}>
                <div className="dropdown">
                    <Dropdown>
                    <Dropdown.Toggle 
                    variant="secondary btn-sm" 
                    id="dropdown-basic">
                        Action
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{backgroundColor:'#73a47'}} >
                        {actions[row['statusFlag']].map((action, i)=> {
                            if(action.value === "DW") {
                                const fiscalYear = new Date(row['fiscalYrEndDate']).getFullYear();
                                const canViewInDW = (fiscalYear <= row['adtrPublicationYear']);
                                //const tooltipText = `ADTRs for reporting years after ${row['adtrPublicationYear']} are not yet published in DebtWatch.`
                                //  <TooltipComponent title={!canViewInDW && tooltipText } placement="left" className="ml-0">
                                   return <Dropdown.Item key={i} href="#" onClick={(e)=>handleActionClick(e, action.value, row )} disabled={!canViewInDW}>{action.label}</Dropdown.Item>
                                    // </TooltipComponent>
                            }
                            return <Dropdown.Item key={i} href="#" onClick={(e)=>handleActionClick(e, action.value, row )}>{action.label}</Dropdown.Item>
                        })}
                    </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div> 
        ); 
    }

    const cancelAdtr = (adtrId) => {
        CommonService.showHideSpinner(true);
        var obj ={
            "msgId": null,
            "sysId": null,
            "opr": "cancelAdtr",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "id" : adtrId,
                "user" : loginUserId,
                "env" : 'I'
            }
          } ;
      
        ReportsService.cancelReport(obj)
        .then((res) => res)
        .then(async (result) => {
            CommonService.showHideSpinner(false);

            if (result.data.errors && result.data.errors.length > 0){
                CommonService.displayServerMessage(result.data.errors[0].message, AlertType.Error)
            }
            else{
                CommonService.displayServerMessage("The transaction has been cancelled and an acknowledgement email has been sent.", AlertType.Success)
                getAdtrWorkLoad();
            }
        });
    }

    const handleActionClick = (e, action, row) => {
        const adtrId = row.adtrId;
        if( action === 'C' ) {
            swal("Are you sure you want to permanently cancel this transaction?", {
                buttons: ["No", "Yes"],
            }).then((value) => {
               if(value){
                cancelAdtr(adtrId);
               }
            });
        } else if( action === 'E') {
            navigate(`/adtr-yfs/${row.cdiacNbr}`, {state: {appState:row}});
        } else if( action === 'PEND') {
            navigate(`/adtr/${row.cdiacNbr}`, {state:{appState: row}});
        } else if( action === 'PD') {
            navigate(`/adtr/${row.cdiacNbr}`, {state: {appState: row}});
        } else if( action === 'R') {
            alert("Clicked Review");
        } else if( action === 'SH') {
            navigate(`/admin/status-history-upload-documents/${row.cdiacNbr}`);
        }
    }   

    const columns = [{
        dataField: 'cdiacNbr',
        text: 'CDIAC #',
        sort: true
      }, 
      {
        dataField: 'fiscalYrEndDate',
        text: 'Fiscal Yr End Date',
        sort: true,
        formatter: (row) => CommonService.dateFormatter(row['fiscalYrEndDate']),
        //hidden: reportStatus === "view-previous" ? false : true
      },
      {
        dataField: 'issueStatus',
        text: 'Status',
        sort: true
      },{
        dataField: 'issueName',
        text: 'Issue Name',
        sort: true
      },{
        dataField: 'issuerName',
        text: 'Issuer Name',
        sort: true
      }, {
        dataField: 'projectName',
        text: 'Project Name',
        sort: true
      }, {
        dataField: 'actualSaleDate',
        text: 'Actual Sale Date',
        sort: true,
        formatter: (row) => CommonService.dateFormatter(row['actualSaleDate'])
      },{
        dataField: 'principalSaleAmt',
        text: 'Principal Amount',
        sort: true,
        formatter: (row) => CommonService.currencyFormatter(row['principalSaleAmt']),
      },{
        dataField: 'retiredFlag',
        text: 'Ongoing Reportable',
        sort: true,
        hidden: reportStatus === "view-previous" ? false : true
      },{
        dataField: 'adtrBatchId',
        text: 'Batch #',
        sort: true
      },{ 
        dataField: "",
        text: "Action", 
        formatter: viewFormatter,
    }
    
    ]
    return (
        <div>
            <DataGrid
            title="Annual Debt Transparency Reports"
            dataSource={adtrs}
            sortField='cdiacNbr'
            searchToolTip="Use the search feature to quickly retrieve the system code values"
            emptyDataMessage='No data available to display'
            >
            {columns.map((column, i) => {
                return (
                <Column 
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort} 
                body={column.formatter}
                hidden={column.hidden}
                />)
                }) 
            } 
            </DataGrid>
        </div>
    )
}

export default ADTRReports
